import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MenuIcon from "@material-ui/icons/Menu";
import GP_Final_logo_transparent_background from "../../Images/GP_Final_logo_transparent_background.png";
import { Box, Button, Paper } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  appBar: {
    paddingTop: "10px",
    paddingBottom: "10px",
    backgroundColor: "#fff",
    [theme.breakpoints.up("sm")]: {
      paddingTop: "20px",
      paddingBottom: "20px",
    },
  },
  logoContainer: {
    marginTop: "5px",
    marginRight: theme.spacing(2),
  },
  logo: {
    // width: 'auto',
    height: "20px",
    [theme.breakpoints.up("sm")]: {
      height: "50px",
    },
    cursor: "pointer",
  },
  button: {
    color: "#000",
    fontWeight: 900,
    fontFamily: "FuturaPt-Demi",
    marginRight: "10px",
    fontSize: "16px",
  },
  mobileButton: {
    color: "#000",
    textTransform: "none",
  },
  title: {
    display: "none",
    color: "#000",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#B20502",
    "&:hover": {
      backgroundColor: "#C0392B",
    },
    //marginRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      //marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  dropdown: {
    position: "absolute",
    color: "#000",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "pink",
    marginRight: theme.spacing(10),
    marginLeft: 0,
    width: "auto",
    height: "80px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 4px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 4px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "gray",
      outline: "1px solid slategrey",
    },
    padding: theme.spacing(0, 2),
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    //position: 'absolute',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    // padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    //paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "space-between",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  menu: {
    // width:'350px'
    marginTop: "83px",
  },
  mobileMenu: {
    marginTop: "45px",
    marginLeft: "15px",
  },
  collapse: {
    backgroundColor: "#fff",
    zIndex: 1000,
    marginTop: 0,
    position: "fixed",
    width: "100%",
    left: 0,
    right: 0,
    display: "block",
    [theme.breakpoints.up("sm")]: {
      //marginTop:63,
      display: "block",
    },
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  listItemText: {
    color: "#000",
    fontSize: "1em",
    fontWeight: 600,
  },
  subListItemText: {
    color: "#000",
    fontSize: "0.8em",
    paddingLeft: 20,
    fontWeight: 600,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const Header = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(false);
  const [openProduct, setOpenProduct] = useState(false);
  const [productMenu, setProductMenu] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [brandNo, setBrandNo] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  const isMenuOpen = Boolean(anchorEl);
  const isProductMenuOpen = Boolean(productMenu);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setProductMenu(false);
    handleMobileMenuClose();
  };
  const handleAirFilterMenu = () => {
    navigate(routes.AIRFILTER);
    setAnchorEl(null);
    setProductMenu(false);
    handleMobileMenuClose();
  };
  const handleFuelFilterMenu = () => {
    navigate(routes.FUELFILTER);
    setAnchorEl(null);
    setProductMenu(false);
    handleMobileMenuClose();
  };
  const handlePackagingSolutionsMenu = () => {
    navigate(routes.PACKAGINGSOLUTIONS);
    setAnchorEl(null);
    setProductMenu(false);
    handleMobileMenuClose();
  };
  const handleOilFilterMenu = () => {
    navigate(routes.OILFILTER);
    setAnchorEl(null);
    setProductMenu(false);
    handleMobileMenuClose();
  };

  const handleAirFilterMobileMenu = () => {
    navigate(routes.AIRFILTER);
    setAnchorEl(null);
    setProductMenu(false);
    setOpen(false);
  };
  const handleFuelFilterMobileMenu = () => {
    navigate(routes.FUELFILTER);
    setAnchorEl(null);
    setProductMenu(false);
    setOpen(false);
  };
  const handleOilFilterMobileMenu = () => {
    navigate(routes.OILFILTER);
    setAnchorEl(null);
    setProductMenu(false);
    setOpen(false);
  };
  const handlePackagingSolutionsMobileMenu = () => {
    navigate(routes.PACKAGINGSOLUTIONS);
    setAnchorEl(null);
    setProductMenu(false);
    setOpen(false);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleLookup = async (e) => {
    try {
      if (brandNo !== "") {
        setShowLoader(true);
        const resp = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/getBrandAndParts?brand_no=${brandNo}`
        );
        const data = await resp.json();
        console.log(data);
        if (data.length > 0) {
          setShowLoader(false);
          navigate(routes.FILTERLOOKUP, { state: { partData: data } });
        } else {
          setShowLoader(false);
          navigate(routes.FILTERLOOKUP, { state: { partData: [] } });
        }
      }
    } catch (e) {
      console.log(e);
      setShowLoader(false);
      //navigate(routes.FILTERLOOKUP, { state: { partData: false } })
    }
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={handleMenuClose}
        className={classes.menu}
      >
        <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
        <MenuItem onClick={handleMenuClose}>My account</MenuItem>
      </Menu>

      <Menu
        anchorEl={productMenu}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isProductMenuOpen}
        onClose={handleMenuClose}
        className={classes.menu}
      >
        <MenuItem onClick={handleOilFilterMenu}>OIL FILTERS</MenuItem>
        <MenuItem onClick={handleAirFilterMenu}>AIR FILTERS</MenuItem>
        <MenuItem onClick={handleFuelFilterMenu}>FUEL FILTERS</MenuItem>
        <MenuItem onClick={handlePackagingSolutionsMenu}>
          PACKAGING SOLUTIONS
        </MenuItem>
      </Menu>
    </>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Collapse
      in={open}
      timeout="auto"
      unmountOnExit
      className={classes.collapse}
    >
      <Paper>
        <List component="div" disablePadding>
          <ListItem button onClick={() => navigate(routes.HOME)}>
            <ListItemText
              primary="HOME"
              classes={{ primary: classes.listItemText }}
            />
          </ListItem>
          {/* <ListItem button>
            <ListItemText
              primary="CATALOG"
              onClick={() => navigate(routes.CATALOG)}
              classes={{ primary: classes.listItemText }}
            />
          </ListItem> */}

          <ListItem button onClick={() => setOpenProduct(!openProduct)}>
            <ListItemText
              primary="PRODUCT"
              classes={{ primary: classes.listItemText }}
            />
            {openProduct ? (
              <ExpandLess style={{ color: "#000" }} />
            ) : (
              <ExpandMore style={{ color: "#000" }} />
            )}
          </ListItem>
          <Collapse in={openProduct} timeout="auto" unmountOnExit>
            <ListItem button onClick={handleOilFilterMobileMenu}>
              <ListItemText
                primary="OIL FILTER"
                classes={{ primary: classes.subListItemText }}
              />
            </ListItem>
            <ListItem button onClick={handleAirFilterMobileMenu}>
              <ListItemText
                primary="AIR FILTER"
                classes={{ primary: classes.subListItemText }}
              />
            </ListItem>
            <ListItem button onClick={handleFuelFilterMobileMenu}>
              <ListItemText
                primary="FUEL FILTER"
                classes={{ primary: classes.subListItemText }}
              />
            </ListItem>
            <ListItem button onClick={handlePackagingSolutionsMobileMenu}>
              <ListItemText
                primary="PACKAGING SOLUTIONS"
                classes={{ primary: classes.subListItemText }}
              />
            </ListItem>
          </Collapse>
          <ListItem button onClick={() => navigate(routes.QUALITY)}>
            <ListItemText
              primary="QUALITY"
              classes={{ primary: classes.listItemText }}
            />
          </ListItem>
          <ListItem button onClick={() => navigate(routes.ABOUTUS)}>
            <ListItemText
              primary="ABOUT"
              classes={{ primary: classes.listItemText }}
            />
          </ListItem>
          <ListItem button onClick={() => navigate(routes.CONTACT)}>
            <ListItemText
              primary="CONTACT"
              classes={{ primary: classes.listItemText }}
            />
          </ListItem>
          <ListItem button onClick={() => navigate(routes.BLOGS)}>
            <ListItemText
              primary="BLOGS"
              classes={{ primary: classes.listItemText }}
            />
          </ListItem>
        </List>
      </Paper>
    </Collapse>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Box className={classes.logoContainer}>
            <img
              src={GP_Final_logo_transparent_background}
              onClick={() => navigate(routes.HOME)}
              alt=""
              className={classes.logo}
            />
          </Box>

          <div className={classes.grow} />

          <div className={classes.sectionDesktop}>
            <Button
              className={classes.button}
              onClick={() => navigate(routes.HOME)}
            >
              Home
            </Button>
            {/* <Button
              className={classes.button}
              onClick={() => navigate(routes.CATALOG)}
            >
              Catalog
            </Button> */}

            <Button
              onClick={(event) => setProductMenu(event.currentTarget)}
              className={classes.button}
              endIcon={<ArrowDropDownIcon>send</ArrowDropDownIcon>}
            >
              Product
            </Button>
            <Button
              className={classes.button}
              onClick={() => navigate(routes.QUALITY)}
            >
              Quality
            </Button>
            <Button
              className={classes.button}
              onClick={() => navigate(routes.ABOUTUS)}
              //  endIcon={<ArrowDropDownIcon>send</ArrowDropDownIcon>}
            >
              About
            </Button>
            <Button
              className={classes.button}
              onClick={() => navigate(routes.CONTACT)}
            >
              Contact
            </Button>

            <Button
              className={classes.button}
              onClick={() => navigate(routes.BLOGS)}
            >
              BLOGS
            </Button>
          </div>

          {/* <div
            style={{
              marginLeft: '20px',
              display: 'flex',
              borderRadius: '5px',
              alignItems: 'center',
              backgroundColor: gpColors.logoBrown,
            }}
          >
            <div className={classes.search}>
              <InputBase
                placeholder="Part No."
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                inputProps={{ 'aria-label': 'search' }}
                onChange={(e) => setBrandNo(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleLookup()}
              />
            </div>
            <div className={classes.searchIcon} onClick={handleLookup}>
              <SearchIcon />
            </div>
          </div> */}

          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              // onClick={handleMobileMenuOpen}
              onClick={() => setOpen(!open)}
              style={{ color: "#B20502" }}
            >
              <MenuIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <Backdrop className={classes.backdrop} open={showLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
};
export default Header;
